export const SELECTED_OVERLAY_LOD_MIN_HANDLES = 5000
export const SELECTED_OVERLAY_LOD_MIN_SCREEN_PX = 0.75

export function shouldUseSelectedOverlayLod({
  selectedCount,
  isInteracting,
  hasSelectedColorMap = false,
  hasSoloLayers = false,
  hasShiftSelectedLayers = false,
  hasIsolatedLayer = false,
  minHandles = SELECTED_OVERLAY_LOD_MIN_HANDLES,
}) {
  return selectedCount >= minHandles
    && isInteracting
    && !hasSelectedColorMap
    && !hasSoloLayers
    && !hasShiftSelectedLayers
    && !hasIsolatedLayer
}

export function shouldSkipSelectedOverlayEntity({
  useLod,
  screenSizePx,
  minScreenPx = SELECTED_OVERLAY_LOD_MIN_SCREEN_PX,
}) {
  return !!useLod && screenSizePx < minScreenPx
}
